export default __webpack_public_path__ + "static/media/attention.ca89e559.svg";